<template>
  <div class="w-72 mt-12 drop-shadow-lg z-[70] fixed bg-white rounded-md" v-if="$store.state.mainFilterSearch.filter_isOpen">
    <div class="p-3 text-grey-custom">
      <div class="grid grid-cols-2">
        <p class="col-span-2 text-md font-bold text-blue-custom">
          ครัวเรือนเปราะบาง
          <!-- <small>Picked: {{ fragilePicked_prop }}</small> -->
        </p>

        <!-- <div class="col-span-2 py-1"></div> -->
        <div class="col-span-1 py-1">
          <button class="border-gray-custom px-5 rounded-md py-1 w-100" @click="fragilePicked_prop = ['0', '1', '2', '3'];">
            <p class="text-center">เลือกทั้งหมด</p>
          </button>
        </div>
        <div class="col-span-1 py-1">
          <button class="border-gray-custom px-5 rounded-md py-1 w-100" @click="fragilePicked_prop = [];">
            <p class="text-center">ไม่เลือกทั้งหมด</p>
          </button>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="one" value="0" v-model="fragilePicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="one" class="ml-1"> เปราะบางระดับ 0</label>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="two" value="1" v-model="fragilePicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="two" class="ml-1"> เปราะบางระดับ 1</label>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="three" value="2" v-model="fragilePicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="three" class="ml-1"> เปราะบางระดับ 2</label>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="four" value="3" v-model="fragilePicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="four" class="ml-1"> เปราะบางระดับ 3</label>
        </div>

        <hr class="col-span-2 border-gray border my-2">

        <p class="col-span-2 text-md font-bold text-blue-custom">
          สภาพปัญหา
          <!-- <small>Picked: {{ probPicked_prop }}</small> -->
        </p>
        <div class="col-span-1 py-1">
          <button class="border-gray-custom px-5 rounded-md py-1 w-100"
            @click="probPicked_prop = ['0', '1', '2', '3', '4', '5', '6', '7', '8'];">
            <p class="text-center">เลือกทั้งหมด</p>
          </button>
        </div>
        <div class="col-span-1 py-1">
          <button class="border-gray-custom px-5 rounded-md py-1 w-100" @click="probPicked_prop = [];">
            <p class="text-center">ไม่เลือกทั้งหมด</p>
          </button>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="one-prob" value="0" v-model="probPicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="one-prob" class="ml-1"> ที่อยู่อาศัย</label>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="two-prob" value="1" v-model="probPicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="two-prob" class="ml-1"> สุขภาพ</label>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="three-prob" value="2" v-model="probPicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="three-prob" class="ml-1"> การศึกษา</label>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="four-prob" value="3" v-model="probPicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="four-prob" class="ml-1"> มีงานทำ/รายได้</label>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="five-prob" value="4" v-model="probPicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="five-prob" class="ml-1"> ครอบครัว</label>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="six-prob" value="5" v-model="probPicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="six-prob" class="ml-1"> ความรุนแรง</label>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="seven-prob" value="6" v-model="probPicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="seven-prob" class="ml-1"> ค้ามนุษย์</label>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="eight-prob" value="7" v-model="probPicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="eight-prob" class="ml-1"> การเข้าถึงสิทธิ</label>
        </div>
        <div class="col-span-1 py-1">
          <input type="checkbox" id="nine-prob" value="8" v-model="probPicked_prop" class="
                          rounded
                          border-gray-300
                          text-blue-custom
                          focus:border-transparent
                          focus:ring-transparent
                        " />
          <label for="nine-prob" class="ml-1"> อื่นๆ</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, watch, ref } from "vue";
// import axios from "axios"
import { useStore } from "@/store";

const store = useStore();
const props = defineProps({
  valueSelected: {
    type: String,
  },
  filterBtnState: Boolean,
  fragilePicked: Array,
  propPicked: Array,
});
const emits = defineEmits(["update:filterBtnState", "click:cancel", "click:save","update:fragilePicked","update:probPicked"]);
const fragilePicked_prop = ref(store.state.main.fragilePicked);
const probPicked_prop = ref(store.state.main.probPicked);

watch(
  () => props.filterBtnState,
  (newval) => {
    if (newval == true) {
      store.commit("mainFilterSearch/setFilterIsOpen", newval);
    } else {
      hideDropdown();
    }
  }
);

watch(
  () => fragilePicked_prop.value,
  (newval) => {
    store.commit("main/setFragilePicked", newval);
  }
);

watch(
  () => probPicked_prop.value,
  (newval) => {
    store.commit("main/setProbPicked", newval);
  }
);

const hideDropdown = () => {
  store.commit("mainFilterSearch/setFilterIsOpen", false);

  setTimeout(() => {
    emits("update:filterBtnState", false);
  }, 450);
};

const handleClickCancel = () => {
  hideDropdown();
  organizeSelected.value = null
  provinceSelected.value = null
  districtSelected.value = null
  subdistrictSelected.value = null
  villageSelected.value = null
  emits("click:cancel");

};

const handleClickSave = () => {
  store.commit("mainFilterSearch/setFilterIsOpen", false);
  let result = {}
  result.province = props.valueSelected == "จังหวัด" ? provinceSelected.value : null
  result.district = props.valueSelected == "จังหวัด" ? districtSelected.value : null
  result.subdistrict = props.valueSelected == "จังหวัด" ? subdistrictSelected.value : null
  result.village = props.valueSelected == "จังหวัด" ? villageSelected.value : null
  result.organize = props.valueSelected == "สำนักงานส่งเสริมและสนับสนุนวิชาการ" ? organizeSelected.value : null
  if (props.valueSelected == "จังหวัด") {
    organizeSelected.value = null
  }
  else {
    provinceSelected.value = null
    districtSelected.value = null
    subdistrictSelected.value = null
    villageSelected.value = null
  }
  hideDropdown();
  emits("click:save", result);

};

onMounted(() => {

})
</script>

<style>
.border-gray-custom {
  border: 1px solid #ccc;
}
</style>
